import React from "react";

/**
 * GigAfloat logo — stylized "G" with a wave + upward arrow inside.
 * Two variants: full (mark + wordmark) and mark-only.
 */
export const LogoMark = ({ size = 32, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 48 48"
    fill="none"
    className={className}
    aria-label="GigAfloat logo"
    data-testid="logo-mark"
  >
    <defs>
      <linearGradient id="gf-grad" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#00FF88" />
        <stop offset="100%" stopColor="#14F195" />
      </linearGradient>
      <filter id="gf-glow" x="-50%" y="-50%" width="200%" height="200%">
        <feGaussianBlur stdDeviation="2" />
      </filter>
    </defs>
    <circle cx="24" cy="24" r="22" fill="#050505" stroke="url(#gf-grad)" strokeWidth="1.5" />
    {/* G arc */}
    <path
      d="M33 17a11 11 0 1 0 2 12h-8"
      stroke="url(#gf-grad)"
      strokeWidth="2.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    {/* wave underline */}
    <path
      d="M12 36c3-2 5-2 8 0s5 2 8 0 5-2 8 0"
      stroke="url(#gf-grad)"
      strokeWidth="1.4"
      strokeLinecap="round"
      fill="none"
      opacity="0.7"
    />
    {/* upward tick */}
    <path
      d="M27 22l3-3 3 3"
      stroke="url(#gf-grad)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);

export const Logo = ({ className = "" }) => (
  <div className={`flex items-center gap-2 ${className}`} data-testid="logo-full">
    <LogoMark size={32} />
    <span className="font-display font-extrabold text-[20px] tracking-tight">
      GigAfloat
    </span>
  </div>
);
